/**
 * Technotrade custom JS overrides v4
 *
 * CANONICAL PHONE NUMBERS (user-verified Apr 15 2026 â€” do NOT change):
 *   WA_RFQ   = 919799004515  â†’ +91 97990 04515  RFQ / quote / general sales WhatsApp
 *   WA_DIVYA = 919256816832  â†’ +91 92568 16832  Divya AI product support WhatsApp
 *   VISIBLE  = +91 97993 98083                   Only number shown on website/invoices/documents
 */

/* =============================================
   1. Inject 10-day returns into Shipping & Return tab
   ============================================= */
(function() {
  'use strict';

  function injectReturnsIntoTab() {
    var shippingPanel = document.querySelector('.m-tab-content--tab');
    if (!shippingPanel) return;
    var inner = shippingPanel.querySelector('.m-tab-content__inner');
    if (!inner) return;
    if (inner.querySelector('.tt-returns-tab')) return;

    var html = [
      '<div class="tt-returns-tab">',
      '<hr class="tt-returns-divider">',
      '<h4 class="tt-returns-tab__heading">&#8629; 10-Day No-Questions-Asked Return Policy</h4>',
      '<p>Request a return from your account within 10 days of delivery.</p>',
      '<ul>',
      '<li>Item must be unused, undamaged and in original sealed packaging.</li>',
      '<li>Return transportation cost is borne by the customer.</li>',
      '<li>No restocking charges. Sale-priced items are not eligible.</li>',
      '</ul>',
      '<div class="tt-returns-tab__actions">',
      '<a href="/account/login?return_url=/account" class="tt-returns-tab__btn">Sign in to request a return &rarr;</a>',
      '<a href="/pages/returns-policy" class="tt-returns-tab__link">Read full policy</a>',
      '</div>',
      '</div>'
    ].join('');
    inner.insertAdjacentHTML('beforeend', html);
  }

  function hideRightColumnReturns() {
    var block = document.querySelector('.tt-returns-block');
    if (block) block.style.display = 'none';
  }

  function init() {
    injectReturnsIntoTab();
    hideRightColumnReturns();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* =============================================
   2. Auto-expand coverage calculator on page load
   ============================================= */
document.addEventListener('DOMContentLoaded', function() {
  var calc = document.querySelector('.tt-coverage-calculator');
  if (calc && calc.classList.contains('collapsed')) {
    calc.classList.remove('collapsed');
    var body = calc.querySelector('.tt-calc-body');
    var icon = calc.querySelector('.tt-calc-toggle-icon');
    if (body) {
      body.style.display = 'block';
      body.style.opacity = '1';
      body.style.maxHeight = '2000px';
    }
    if (icon) icon.style.transform = 'rotate(180deg)';
  }
});


/* =============================================
   3. RFQ Button (OOS variant) + Homepage Feature Strip
   ES5 compatible.
   ============================================= */
(function() {
  'use strict';

  // CANONICAL â€” do not change without updating memory/canonical file
  var WA_RFQ   = '919799004515'; // +91 97990 04515 â€” RFQ / quote / general sales
  var WA_DIVYA = '919256816832'; // +91 92568 16832 â€” Divya AI product support

  var RFQ_PREFIX = 'Hi, I would like to request a quote for: ';

  function isProductPage() {
    return window.location.pathname.indexOf('/products/') !== -1;
  }

  function getProductTitle() {
    var el = document.querySelector('h1.m-product-title, h1.product-title, .m-product-info__name h1');
    return el ? el.innerText.trim() : 'your product';
  }

  function getSelectedVariantLabel() {
    var info = document.querySelector('.m-product-info, #product-info, .m-main-product');
    if (!info) info = document;
    var labels = [];
    var els = info.querySelectorAll('.option-label--selected');
    for (var i = 0; i < els.length; i++) {
      var t = els[i].innerText.trim();
      if (t) labels.push(t);
    }
    return labels.join(' / ');
  }

  function buildRFQURL() {
    var msg = RFQ_PREFIX + getProductTitle();
    var v = getSelectedVariantLabel();
    if (v) msg += ' (' + v + ')';
    return 'https://wa.me/' + WA_RFQ + '?text=' + encodeURIComponent(msg);
  }

  // Get MAIN product form only â€” skip cards and quick-views
  function getMainForm() {
    var info = document.querySelector('.m-product-info, #product-info, .m-main-product, [data-section-type="product"]');
    if (info) {
      var f = info.querySelector('form[action="/cart/add"], .m-product-form');
      if (f) return f;
    }
    var forms = document.querySelectorAll('form[action="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var frm = forms[i];
      if (!frm.closest('.m-product-card') && !frm.closest('.quick-view') && !frm.closest('[data-quickview]')) {
        return frm;
      }
    }
    return null;
  }

  function injectRFQ(form) {
    if (!form || form.querySelector('.tt-oos-badge')) return;

    var badge = document.createElement('div');
    badge.className = 'tt-oos-badge';
    badge.innerHTML = 'This variant is currently out of stock';

    var btn = document.createElement('a');
    btn.className = 'tt-rfq-btn';
    btn.innerHTML = '&#128172; Request a Quote on WhatsApp';
    btn.target = '_blank';
    btn.rel = 'noopener noreferrer';

    var container = form.querySelector('.m-product-form__buttons');
    if (container) {
      container.insertBefore(badge, container.firstChild);
      container.insertBefore(btn, container.firstChild);
    } else {
      form.appendChild(badge);
      form.appendChild(btn);
    }
  }

  function updateOOS() {
    var form = getMainForm();
    if (!form) return;
    var atc = form.querySelector('button[name="add"], .m-add-to-cart, .m-product-form__cart-submit');
    var badge = form.querySelector('.tt-oos-badge');
    var rfq = form.querySelector('.tt-rfq-btn');
    if (!atc || !badge || !rfq) return;

    var txt = (atc.innerText || atc.textContent || '').toLowerCase();
    var oos = atc.disabled || atc.hasAttribute('disabled') || atc.classList.contains('disabled') ||
              txt.indexOf('sold') !== -1 || txt.indexOf('unavailable') !== -1;

    if (oos) {
      badge.classList.add('tt-rfq-visible');
      rfq.classList.add('tt-rfq-visible');
      rfq.href = buildRFQURL();
      form.classList.add('tt-oos-state');
    } else {
      badge.classList.remove('tt-rfq-visible');
      rfq.classList.remove('tt-rfq-visible');
      form.classList.remove('tt-oos-state');
    }
  }

  function initRFQ() {
    if (!isProductPage()) return;
    injectRFQ(getMainForm());
    updateOOS();
    var last = null;
    setInterval(function() {
      var form = getMainForm();
      if (!form) return;
      var atc = form.querySelector('button[name="add"], .m-add-to-cart');
      if (!atc) return;
      var state = atc.disabled + '|' + (atc.innerText || '');
      if (state !== last) {
        last = state;
        injectRFQ(form);
        updateOOS();
      }
    }, 350);
  }

  function run() {
    initRFQ();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();


/* =============================================
   4. Cart Page â€” Price Instability Warning Banner
   ============================================= */
(function() {
  'use strict';

  function injectCartWarning() {
    if (window.location.pathname !== '/cart') return;
    if (document.querySelector('.tt-cart-warning')) return;

    var main = document.querySelector('main, #MainContent');
    if (!main) return;

    var banner = document.createElement('div');
    banner.className = 'tt-cart-warning';
    banner.innerHTML =
      '<span class="tt-cart-warning__icon">&#9888;&#65039;</span>' +
      '<span class="tt-cart-warning__text">' +
      '<strong>Prices are updated daily</strong>' +
      'Your price is locked the moment you order, and confirmed on your GST invoice before dispatch. ' +
      'Have a question on stock or bulk pricing? ' +
      'Call or WhatsApp <a href="https://wa.me/919799004515" target="_blank" rel="noopener noreferrer" style="color:#5a3e00;font-weight:600;">+91 97990 04515</a> anytime.' +
      '</span>';

    main.insertBefore(banner, main.firstChild);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectCartWarning);
  } else {
    injectCartWarning();
  }
})();


/* =============================================
   5. Trust Bar â€” inject above fold between ATC and addons (PDP)
   Badges are in product description (below fold); clone them
   above the buy-buttons block so they're always visible.
   ES5 compatible.
   ============================================= */
(function() {
  'use strict';

  var BADGES = [
    { icon: '&#9989;', text: 'GST Invoice on all orders' },
    { icon: '&#128666;', text: 'Pan-India delivery' },
    { icon: '&#128230;', text: 'Bulk pricing for projects' },
    { icon: '&#128295;', text: 'Free technical support' }
  ];

  function isProductPage() {
    return window.location.pathname.indexOf('/products/') !== -1;
  }

  function injectTrustBar() {
    if (!isProductPage()) return;
    if (document.querySelector('.tt-trust-bar')) return;

    var buyBlock = document.querySelector('.m-product-block--buy-buttons');
    if (!buyBlock) return;

    var bar = document.createElement('div');
    bar.className = 'tt-trust-bar';

    var html = '';
    for (var i = 0; i < BADGES.length; i++) {
      html += '<div class="tt-trust-bar__item">' +
        '<span class="tt-trust-bar__icon">' + BADGES[i].icon + '</span>' +
        '<span>' + BADGES[i].text + '</span>' +
        '</div>';
    }
    bar.innerHTML = html;

    // Insert after buy-buttons block
    buyBlock.parentNode.insertBefore(bar, buyBlock.nextSibling);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectTrustBar);
  } else {
    injectTrustBar();
  }
})();


/* TT_MINORDER_SOFT v3 — soft min-order + GSTIN-prefill checkout via URL params (Thread 9, 2026-06-13) */
(function(){
  function getProfile(){try{var s=sessionStorage.getItem('tt_b2b_profile');if(s){var p=JSON.parse(s);if(p&&(p.company_name||p.gstin))return p;}}catch(e){}try{var l=localStorage.getItem('tt_b2b_verified');if(l){var q=JSON.parse(l);if(q&&(q.company_name||q.gstin))return{company_name:q.company_name,gstin:q.gstin,city:q.city};}}catch(e){}return null;}
  function cleanCity(c){if(!c)return'';c=(''+c).trim();if(c.length<2||c.length>30)return'';if(/[0-9,\-\/]/.test(c))return'';return c;}
  function coUrl(p){var a=[];if(p.company_name)a.push('checkout[shipping_address][company]='+encodeURIComponent(p.company_name));if(p.gstin)a.push('checkout[shipping_address][address2]='+encodeURIComponent(p.gstin));var ci=cleanCity(p.city);if(ci)a.push('checkout[shipping_address][city]='+encodeURIComponent(ci));return a.length?'/checkout?'+a.join('&'):'/checkout';}
  function fix(){try{var btns=document.querySelectorAll('button[name="checkout"], [name="checkout"]');for(var i=0;i<btns.length;i++){var b=btns[i];if(b.disabled){b.disabled=false;b.removeAttribute('aria-disabled');b.classList.remove('disabled');b.style.opacity='1';b.style.cursor='pointer';}if(!b.getAttribute('data-tt-bound')){b.setAttribute('data-tt-bound','1');b.addEventListener('click',function(ev){var f=this.closest('form');ev.preventDefault();ev.stopImmediatePropagation();var p=getProfile();if(p){window.location.href=coUrl(p);return;}if(f){if(f.requestSubmit){f.requestSubmit(this);}else{f.submit();}}else{window.location.href='/checkout';}},true);}}var all=document.querySelectorAll('body *');for(var j=0;j<all.length;j++){var el=all[j];if(el.children.length===0&&el.textContent&&el.textContent.indexOf('Minimum order value is')>-1){el.innerHTML='\u24D8 Tip: orders under \u20B91,000 are welcome \u2014 small carts may carry slightly higher per-unit freight, shown at checkout. You can check out now.';el.style.color='#475569';}}}catch(e){}}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',fix);}else{fix();}
  document.addEventListener('cart:refresh',fix);
  var mo=new MutationObserver(function(){fix();});if(document.body)mo.observe(document.body,{childList:true,subtree:true});
})();